import styles from './index.module.less'
import { Image, Dropdown, Button, Row, Col, Divider, Space } from 'antd'
import { Fallback } from '@/pages/workshop/Icons.tsx'
import { useFileUrlPrefix } from 'shj-utils'
import {
  DisconnectOutlined,
  EllipsisOutlined,
  HeartOutlined,
  MinusCircleOutlined,
  PushpinOutlined,
  StarOutlined,
} from '@ant-design/icons'

const ApplicationItem = props => {
  const {
    data,
    onClick,
    onCollect,
    onCollectRemove,
    onNavRemove,
    onAddNav,
    isCollect,
    isNav,
    commonlyRemoveText,
    size,
  } = props
  const [urlPrefix] = useFileUrlPrefix()

  const onMenuClick = ({ key }) => {
    console.log('key', key, data)
    const fn = {
      nav: onAddNav,
      collect: onCollect,
      nav_remove: onNavRemove,
      collect_remove: onCollectRemove,
    }[key]
    fn?.(data)
  }

  const renderMenuItem = (icon, text) => {
    return (
      <Space>
        {icon}
        {text}
      </Space>
    )
  }

  const navMenu = isNav
    ? {
        key: 'nav_remove',
        label: renderMenuItem(<DisconnectOutlined style={{ color: 'red' }} />, '从导航栏移除'),
      }
    : {
        key: 'nav',
        label: renderMenuItem(<PushpinOutlined />, '添加到导航栏'),
      }

  const collectMenu = isCollect
    ? {
        key: 'collect_remove',
        label: renderMenuItem(
          <MinusCircleOutlined style={{ color: 'red' }} />,
          commonlyRemoveText || '移除常用'
        ),
      }
    : {
        key: 'collect',
        label: renderMenuItem(<StarOutlined />, '设为常用'),
      }

  const sizeDict = {
    small: [48, 48],
    normal: [60, 60],
  }
  return (
    <div className={styles.applicationItem} onClick={onClick}>
      <div className={styles.appBg}>
        {/*<div className={styles.appAction}>*/}
        {/*  <Row wrap={false} align="middle">*/}
        {/*    <Col flex={1}>*/}
        {/*      <Button type="text" icon={<PushpinOutlined />} block>*/}
        {/*        /!*导航*!/*/}
        {/*      </Button>*/}
        {/*    </Col>*/}
        {/*    <Divider type="vertical" />*/}
        {/*    <Col flex={1}>*/}
        {/*      <Button type="text" icon={<StarOutlined />} block>*/}
        {/*        /!*常用*!/*/}
        {/*      </Button>*/}
        {/*    </Col>*/}
        {/*  </Row>*/}
        {/*</div>*/}
      </div>

      <div className={styles.appContent}>
        <div className={styles.appIcon}>
          <Image
            width={sizeDict[size || 'normal'][0]}
            height={sizeDict[size || 'normal'][1]}
            src={data.app.icon?.startsWith?.('http') ? data.app.icon : urlPrefix + data.app.icon}
            fallback={Fallback}
            preview={false}
          />
        </div>
        <div className={styles.appName}>{data.app.name}</div>
        <div className={styles.action} onClick={e => e.stopPropagation()}>
          <Dropdown
            menu={{
              onClick: onMenuClick,
              items: [
                // navMenu,
                collectMenu],
            }}
            // trigger={['click']}
          >
            <div style={{ fontSize: 17 }}>
              <EllipsisOutlined />
            </div>
          </Dropdown>
        </div>
      </div>
    </div>
  )
}

export default ApplicationItem
